import { Box, Divider, List, ListItem, ListItemText, Typography } from "@mui/material"


const Information = () => {
  return (
    <>
        <Typography variant="h4" fontWeight="bold" gutterBottom>
           2. Information We Collect
        </Typography>
        <Box ml={4} mt={2}>
            <Typography variant="h5" fontWeight="bold" gutterBottom>
                A. Employee/User Profile Information
            </Typography>
            <List>
                <ListItem>
                    <ListItemText>
                        • Name
                    </ListItemText>
                </ListItem>
                <ListItem>
                    <ListItemText>
                        •  Employee Code
                    </ListItemText>
                </ListItem>
                <ListItem>
                    <ListItemText>
                        • Email Address
                    </ListItemText>
                </ListItem>
                <ListItem>
                    <ListItemText>
                        •  Mobile Number
                    </ListItemText>
                </ListItem>
                <ListItem>
                    <ListItemText>
                        •  Assigned Roles and Departments
                    </ListItemText>
                </ListItem>
                <ListItem>
                    <ListItemText>
                        •  Profile Picture (if uploaded)
                    </ListItemText>
                </ListItem>
            </List>
        </Box>
         <Box ml={4} mt={2}>
            <Typography variant="h5" fontWeight="bold" gutterBottom>
                B.  Customer and Sales Information
            </Typography>
            <List>
                <ListItem>
                    <ListItemText>
                        •  Customer Name, Code, and Category
                    </ListItemText>
                </ListItem>
                <ListItem>
                    <ListItemText>
                        •  Business Details and Location
                    </ListItemText>
                </ListItem>
                <ListItem>
                    <ListItemText>
                        •  Credit Limit and Credit Period
                    </ListItemText>
                </ListItem>
                <ListItem>
                    <ListItemText>
                        •  Visit Status (e.g., yet to visit, visited)

                    </ListItemText>
                </ListItem>
                <ListItem>
                    <ListItemText>
                        •  Uploaded Place Images
                    </ListItemText>
                </ListItem>
                <ListItem>
                    <ListItemText>
                        • Notes and Feedback
                    </ListItemText>
                </ListItem>
            </List>
        </Box>
         <Box ml={4} mt={2}>
            <Typography variant="h5" fontWeight="bold" gutterBottom>
                C. Order and Payment Information
            </Typography>
            <List>
                <ListItem>
                    <ListItemText>
                        •   Order ID and Items
                    </ListItemText>
                </ListItem>
                <ListItem>
                    <ListItemText>
                        •   Product Brand, Category, UOM, Pricing, and VAT %
                    </ListItemText>
                </ListItem>
                <ListItem>
                    <ListItemText>
                        •  Invoice Numbers and Tax Details
                    </ListItemText>
                </ListItem>
                <ListItem>
                    <ListItemText>
                        •   Receipt Uploads
                    </ListItemText>
                </ListItem>
                <ListItem>
                    <ListItemText>
                        •  Outstanding Balances
                    </ListItemText>
                </ListItem>
            </List>
        </Box>
        <Box ml={4} mt={2}>
            <Typography variant="h5" fontWeight="bold" gutterBottom>
                D. Location and Attendance
            </Typography>
            <List>
                <ListItem>
                    <ListItemText>
                        •  GPS Location (during check-in, visit, payment)
                    </ListItemText>
                </ListItem>
                <ListItem>
                    <ListItemText>
                        •  Timestamps for field visits and employee movement
                    </ListItemText>
                </ListItem>
                <ListItem>
                    <ListItemText>
                        •   Real-time location updates (work hour tracking)
                    </ListItemText>
                </ListItem>
                 <ListItem>
                    <ListItemText>
                        •   Enable real-time location tracking every 15 seconds in both foreground and background, only after the user has checked in.
 
                    </ListItemText>
                </ListItem>
            </List>
        </Box>
         <Box ml={4} mt={2}>
            <Typography variant="h5" fontWeight="bold" gutterBottom>
                E.  Device and Technical Info
            </Typography>
            <List>
                <ListItem>
                    <ListItemText>
                        •  Device Identifier
                    </ListItemText>
                </ListItem>
                  <ListItem>
                    <ListItemText>
                        •  App Version and Crash Logs
                    </ListItemText>
                </ListItem>
                  <ListItem>
                    <ListItemText>
                        •   Internet Usage Logs (no browsing tracked)
                    </ListItemText>
                </ListItem>
            </List>
        </Box>
        <Divider sx={{ my: 2 }} />
    </>
   
  )
}

export default Information